<template>
    <div :class="modalHolder">
        <div class="modal_trailer medium">
            <div class="modal_trailer--inner">
                <ul class="grid-x">
                    <li class="cell small-6">
                        <button type="button" name="90秒予告" :class="tabs1ButtonClass" @click="setTrailer1()">90秒予告</button>
                    </li>
                    <li class="cell small-6">
                        <button type="button" name="30秒予告" :class="tabs2ButtonClass" @click="setTrailer2()">30秒予告</button>
                    </li>
                </ul>
                <youtube @ready="ready" :video-id="currentTrailer" player-width="560" player-height="315" :player-vars="videoParams"></youtube>
            </div>
            <button type="button" class="modal_trailer--close" name="close" @click="closeModal"><svg class="icon icon-close-button"><use xlink:href="#icon-close-button"></use></svg></button>
        </div>

        <span class="modal_trailer--overlay" @click="closeModal"></span>
    </div>
</template>

<script>
import Vue from 'vue'
import VueYouTubeEmbed from 'vue-youtube-embed'
Vue.use(VueYouTubeEmbed)
export default {
    name: 'modal-trailer',
    props: {
        isActive: Boolean
    },
    data () {
        return {
            currentTrailer: 'eMxAm1n083Q',
            trailer1: 'eMxAm1n083Q',
            trailer2: 'epVmiu8hi_E',
            player: null,
            videoParams: {
                rel: 0,
                allow: 'encrypted-media',
                allowfullscreen: 1,
                autoplay: 0
            }
        }
    },
    computed: {
        tabs1ButtonClass: function () {
            if (this.currentTrailer === this.trailer1) {
                return 'button_trailer is-active'
            } else {
                return 'button_trailer'
            }
        },
        tabs2ButtonClass: function () {
            if (this.currentTrailer === this.trailer2) {
                return 'button_trailer is-active'
            } else {
                return 'button_trailer'
            }
        },

        modalHolder () {
            if (this.isActive) {
                return 'modal_trailer--holder active'
            } else {
                return 'modal_trailer--holder'
            }
        }
    },
    methods: {
        ready (event) {
            this.player = event.target
        },
        closeModal () {
            this.player.pauseVideo()
            this.$emit('closeModal')
        },

        setTrailer1: function () {
            this.currentTrailer = this.trailer1
        },
        setTrailer2: function () {
            this.currentTrailer = this.trailer2
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalTrailer.vue